module.exports = __webpack_public_path__ + "static/media/white-logo.a3a16ab7.png";